const setFirstViewElm = document.querySelector('.firstVewSet');
const targetHtml = document.querySelector('html');
// const addClass = 'bgWhite';

window.addEventListener('scroll', () => {
    if (setFirstViewElm) {
        console.log("あります");
        const scrollY = window.pageYOffset;
        if (scrollY > setFirstViewElm.offsetHeight) {
            targetHtml.classList.add('bgWhite');
        } else {
            targetHtml.classList.remove('bgWhite');
        }
    } else{
        console.log("ありません");
    }
});